
import React from 'react';
import CustomAppBar from "../../commons/AppBar";
import { Button, CircularProgress, Divider, Grid } from "@material-ui/core";
import Utils from "../../providers/Utils";
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import AlertNew from '../../commons/dialogs/AlertNew';
import UtilsFinanciar from './UtilsFinanciar';
import OpenDownloadBilant from './Dialogs/OpenDownloadBilant';
import LocalStorage from '../../providers/LocalStorage';




export default class BilantNou extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            bilant: { tipBilant: 'Anual', an: new Date().getFullYear() - 1, luna: new Date().getMonth() + 1, denumire: '', tip: 'Micro' },
            years: new Utils().getLast10Years(),
            year: new Date().getFullYear() - 1,
            tipuriBilant: this.u.tipuriBilant,
            openAlertBilant: false,
            openAlertBilantImport: false,
            bilantExistent: {},
            openAlertRows: false,
            titleAlertRows: ``,
            messageRows: ``,
            bilantHead: '',
            openDownloadBilant: false,
            loading:false,
            alertView:false
        }

    };


    u = new Utils()
    ws = new Ws()
    uF = new UtilsFinanciar()
    ls = new LocalStorage().GetUserData()


    componentDidMount() {
        this.access()

    }

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.AccessFinanciar === 1 ? false : true })
        }


    }


    changeBilant = (ev) => {

        let bilantOld = { ...this.state.bilant }

        let v = ev.target.value
        let n = ev.target.name

        bilantOld[n] = v

        this.setState({ bilant: bilantOld })
    }


    addBilantImport = async () => {
        let bilant = {
            an: this.state.bilant.an,
            luna: 12,
            tip: this.state.bilant.tip
        }


        let getBilanturi = await this.ws.customSelect('select * from fin_import_bilant_head where an = @p1 and isnull(sters,0) != 1 ', {
            p1: this.state.bilant.an
        })


        if (getBilanturi.Succes) {

            let bilanturi = [...getBilanturi.Content]


            if (bilanturi.length > 0) {

                console.log('exista bilant :>> ',);

                this.setState({
                    openAlertBilantImport: true,
                    bilantExistent: bilanturi[0]
                })

            } else {

                console.log('bilant :>> ', bilant);


                let insertBilant = await this.ws.insert('fin_import_bilant_head', bilant)

                if (insertBilant.Succes) {

                    this.setState({ bilantHead: insertBilant.Content[0].id })

                    this.selectFile('import-bilant')
                }

            }
        }

    }

    addBilant = async () => {

        let bilant = {
            an: this.state.bilant.an,
            luna: 12,
            tip: this.state.bilant.tip
        }


        let getBilanturi = await this.ws.customSelect('select * from fin_import_bilant_head where an = @p1 and isnull(sters,0) != 1 ', {
            p1: this.state.bilant.an
        })


        if (getBilanturi.Succes) {

            let bilanturi = [...getBilanturi.Content]


            if (bilanturi.length > 0) {

                console.log('exista bilant :>> ',);

                this.setState({
                    openAlertBilant: true,
                    bilantExistent: bilanturi[0]
                })

            } else {

                console.log('bilant :>> ', bilant);


                let insertBilant = await this.ws.insert('fin_import_bilant_head', bilant)

                if (insertBilant.Succes) {

                    this.props.history.push(`/bilantrows/${insertBilant.Content[0].id}`)
                }

            }
        }


    }

    deleteBilant = async () => {


        console.log('this.state.bilantExistent :>> ', this.state.bilantExistent);

        let delBilant = await this.ws.update('fin_import_bilant_head', { sters: 1 }, { id: this.state.bilantExistent.id })

        if (delBilant.Succes) {
            this.setState({ openAlertBilant: false }, () => {
                this.addBilant()
            })
        }


    }


    deleteBilantImport = async () => {


        console.log('this.state.bilantExistent :>> ', this.state.bilantExistent);

        let delBilant = await this.ws.update('fin_import_bilant_head', { sters: 1 }, { id: this.state.bilantExistent.id })

        if (delBilant.Succes) {
            this.setState({ openAlertBilantImport: false }, () => {
                this.addBilantImport()
            })
        }


    }


    selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }


    importBilant = async (id) => {

        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);






        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadbilant('Bilant/ImportBilant', saveFile, this.state.bilant.an);

            console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {

                let bilantRowsToAdd = uploadImage.Content

                let bilantRows = []

                if (this.state.bilant.tip === 'Micro') {

                    if (Number(this.state.bilant.an) <= 2018) {

                        bilantRows = this.uF.bilantMicroStruct_2016
                    } else if (Number(this.state.bilant.an) > 2018) {
                        bilantRows = this.uF.bilantMicroStruct_2020
                    }

                } else if (this.state.bilant.tip === 'Macro') {
                    if (Number(this.state.bilant.an) <= 2016) {

                        bilantRows = this.uF.bilantMicroStruct_2016
                    } else if (Number(this.state.bilant.an) > 2018) {
                        bilantRows = this.uF.bilantMicroStruct_2020
                    }

                } else {
                    if (Number(this.state.bilant.an) <= 2016) {

                        bilantRows = this.uF.bilantMicroStruct_2016
                    } else if (Number(this.state.bilant.an) > 2018) {
                        bilantRows = this.uF.bilantMicroStruct_2020
                    }

                }


                for (let i = 0, n = bilantRows.length; i < n; i++) {



                    let isFound = false



                    loop2:
                    for (let j = 0, m = bilantRowsToAdd.length; j < m; j++) {



                        if (bilantRows[i].jsId === '15' && bilantRowsToAdd[j].MyCol1) {

                            if (bilantRowsToAdd[j].MyCol1.includes('DATORII')) {
                                console.log('bilantRowsToAdd :>> ', bilantRowsToAdd[j]);
                                console.log('bilantRows[i] :>> ', bilantRows[i]);

                            }


                        }




                        if (bilantRowsToAdd[j]['MyCol1']) {
                            if (this.u.replaceDiacritice(bilantRowsToAdd[j]['MyCol1']).includes(this.u.replaceDiacritice(bilantRows[i].searchText))) {
                                // console.log('bilantRowsToAdd[idx].F39  :>> ', bilantRowsToAdd[idx]);
                                bilantRows[i].soldInitial = bilantRowsToAdd[j].F33 || 0
                                bilantRows[i].soldFinal = bilantRowsToAdd[j].F39 || 0

                                isFound = true


                                break loop2
                            }
                        }


                    }


                    if (!isFound) {

                        this.setState({
                            openAlertRows: true,
                            titleAlertRows: `Coloana ${bilantRows[i].bilantDescription} nu a fost gasita in bilantul adaugat ! `,
                            messageRows: `Va rugam revizuiti bilantul si incercati sa il importati din nou.`
                        }, async () => {
                            let delBilant = await this.ws.update('fin_import_bilant_head', { sters: 1 }, { an: this.state.bilant.an })
                        })


                        return false
                    }





                    // let idx = bilantRowsToAdd.findIndex(br => this.u.replaceDiacritice(br.MyCol1 || ' ').indexOf(this.u.replaceDiacritice(bilantRows[i].searchText))  !== -1)


                    // if (idx !== -1) {

                    //     console.log('bilantRowsToAdd[idx].F39  :>> ', bilantRowsToAdd[idx]);
                    //     bilantRows[i].soldInitial = bilantRowsToAdd[idx].F33 || 0
                    //     bilantRows[i].soldFinal = bilantRowsToAdd[idx].F39 || 0
                    // } else {

                    //     this.setState({
                    //         openAlertRows: true,
                    //         titleAlertRows: `Coloana ${bilantRows[i].bilantDescription} nu a fost gasita in bilantul adaugat ! `,
                    //         messageRows: `Va rugam revizuiti bilantul si incercati sa il importati din nou.`
                    //     })


                    //     return false
                    // }

                }

                this.setState({ openAlertNewBilant: true,
                                loading:true })





                console.log('bilantRows :>> ', bilantRows);


                for (let i = 0, n = bilantRows.length; i < n; i++) {
                    let bilant = {
                        id_head: this.state.bilantHead,
                        descriere: bilantRows[i].bilantDescription,
                        js_id: bilantRows[i].jsId,
                        sold_initial: bilantRows[i].soldInitial,
                        sold_final: bilantRows[i].soldFinal
                    }

                    console.log('bilantRows[i] :>> ', bilantRows[i]);

                    console.log('bilant :>> ', bilant);

                    let insertBilantRow = await this.ws.insert('fin_import_bilant_rows', bilant)

                    if (insertBilantRow.Succes) {

                    }
                }
            }

            this.setState({loading:false}, () =>{

                this.props.history.push(`/managementbilanturi`)

            })
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }



    downloadBilant = () => {

        let downloadFile = `${this.state.bilant.an}_${this.state.bilant.tip}.xlsx`

        console.log('downloadFile :>> ', downloadFile);


        let adress = `${this.ws.adresaDownloadBilant}/${downloadFile}`

        window.open(adress)
    }



    inapoi = () => {

        this.props.history.goBack()
    }


    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title='' />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />


                {this.state.loading &&
                    <div className='loading-div' >

                        <CircularProgress
                            style={{
                                width: 60,
                                height: 60,
                                color: '#25e048',
                                marginTop: '40%'
                            }}
                            value={20}

                        />
                        <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                    </div>
                }


                <OpenDownloadBilant
                    open={this.state.openDownloadBilant}
                    dialogClose={() => { this.setState({ openDownloadBilant: false }) }}
                    bilant={this.state.bilant}
                    changeBilant={this.changeBilant}
                    years={this.state.years}
                    tipuriBilant={this.state.tipuriBilant}
                    downloadBilant={this.downloadBilant}
                />

                <AlertNew
                    open={this.state.openAlertNewBilant}
                    dialogClose={() => { this.setState({ openAlertNewBilant: false }) }}
                    title={'Bilantul a fost importat cu succes !'}
                    mesaj={''}
                    yesFunction={() => { this.setState({ openAlertNewBilant: false }) }}
                    noButtonDisplay={1}
                />

                <AlertNew
                    open={this.state.openAlertBilant}
                    dialogClose={() => { this.setState({ openAlertBilant: false }) }}
                    title={'Exista deja un bilant in anul selectat, doriti sa il stergeti ?'}
                    mesaj={'Odata sters, bilantul nu va mai putea fi recuperat !'}
                    yesFunction={this.deleteBilant}
                />

                <AlertNew
                    open={this.state.openAlertBilantImport}
                    dialogClose={() => { this.setState({ openAlertBilantImport: false }) }}
                    title={'Exista deja un bilant in anul selectat, doriti sa il stergeti ?'}
                    mesaj={'Odata sters, bilantul nu va mai putea fi recuperat !'}
                    yesFunction={this.deleteBilantImport}
                />

                <AlertNew
                    open={this.state.openAlertRows}
                    dialogClose={() => { this.setState({ openAlertRows: false }) }}
                    title={this.state.titleAlertRows}
                    mesaj={this.state.messageRows}
                    yesFunction={() => { this.setState({ openAlertRows: false }) }}
                    noButtonDisplay={1}
                />


                <Grid style={{ maxWidth: 1200, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.financiar.adaugaBilant} </h1>
                    </Grid>


                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.financiar.informatiiBilant}</h5>


                                    <Divider className='pm-divider' style={{ marginBottom: 20 }} />
                                </Grid>


                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>
                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                            <div style={{ position: 'relative', textAlign: 'left' }}>
                                                <select
                                                    id='tip_bilant'
                                                    style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                    className='add-project-input'
                                                    type="text"
                                                    margin="normal"
                                                    name='tipBilant'
                                                    // disabled={this.state.tip_bilantDisabled !== 1 ? true : false}
                                                    value={'Anual'}
                                                    onChange={this.changeBilant}
                                                // placeholder={this.dictionary.pontaje.tipBilant}
                                                // onBlur={this.props.updateAngajatData}
                                                >




                                                    <option value={'Anual'}>Anual</option>


                                                </select>
                                                <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.financiar.tipBilant}</label>
                                            </div>

                                        </Grid>

                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                            <div style={{ position: 'relative', textAlign: 'left' }}>
                                                <select
                                                    id='an'
                                                    style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                    className='add-project-input'
                                                    type="text"
                                                    margin="normal"
                                                    name='an'
                                                    // disabled={this.state.tip_bilantDisabled !== 1 ? true : false}
                                                    value={this.state.bilant.an || ''}
                                                    onChange={this.changeBilant}
                                                // placeholder={this.dictionary.pontaje.tip_bilantCautaLucrator}
                                                // onBlur={this.props.updateAngajatData}
                                                >




                                                    {this.state.years.map((s, idx) => {
                                                        return (
                                                            <option key={idx} value={s}>{s}</option>
                                                        )
                                                    })}


                                                </select>
                                                <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.financiar.an}</label>
                                            </div>

                                        </Grid>

                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                            <div style={{ position: 'relative', textAlign: 'left' }}>
                                                <input
                                                    style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                    id='denumire'
                                                    type="text"
                                                    step='any'
                                                    className='add-project-input'
                                                    placeholder={'Ex: 2223 lei'}
                                                    margin="normal"
                                                    name='denumire'
                                                    value={this.state.bilant.denumire || ''}
                                                    onChange={this.changeBilant}
                                                // onBlur={this.props.updateAngajatData}
                                                />
                                                <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.financiar.denumire}</label>
                                            </div>

                                        </Grid>

                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                            <div style={{ position: 'relative', textAlign: 'left' }}>
                                                <select
                                                    id='tip'
                                                    style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                    className='add-project-input'
                                                    type="text"
                                                    margin="normal"
                                                    name='tip'
                                                    // disabled={this.state.tip_bilantDisabled !== 1 ? true : false}
                                                    value={this.state.bilant.tip || ''}
                                                    onChange={this.changeBilant}
                                                // placeholder={this.dictionary.pontaje.tip_bilantCautaLucrator}
                                                // onBlur={this.props.updateAngajatData}
                                                >




                                                    {this.state.tipuriBilant.map((s, idx) => {
                                                        return (
                                                            <option key={idx} value={s.id}>{s.nume}</option>
                                                        )
                                                    })}


                                                </select>
                                                <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.financiar.tipEntitate}</label>
                                            </div>

                                        </Grid>

                                        <Grid item style={{ textAlign: 'left', paddingTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                            <Button
                                                style={{ marginRight: 20 }}

                                                className={'add-button-blue'} onClick={this.addBilant}  >

                                                <i style={{
                                                    fontSize: 14,
                                                    marginRight: 10
                                                }} className='material-icons'>add</i>  {this.dictionary.financiar.adaugaBilantNou}
                                            </Button>

                                            <Button
                                                style={{ marginRight: 20 }}

                                                className={'inapoi-button-blue'} onClick={this.inapoi}  >

                                                <i style={{
                                                    fontSize: 14,
                                                    marginRight: 10
                                                }} className='material-icons'>keyboard_arrow_left</i>  {this.dictionary.financiar.inapoi}
                                            </Button>

                                        </Grid>


                                        <Grid item style={{ textAlign: 'right', paddingTop: 20 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                            <span
                                                onClick={() => { this.setState({ openDownloadBilant: true }) }}
                                                style={{
                                                    color: '#3e8ae6',
                                                    cursor: 'pointer',
                                                    display: 'block',
                                                    paddingTop: 10,
                                                    textDecoration: 'underline'
                                                }}><i style={{ verticalAlign: 'sub', fontSize: 20 }} className='material-icons'>download</i> {this.dictionary.financiar.downloadTemplateBilant}</span>



                                        </Grid>

                                        <Grid item style={{ textAlign: 'right', paddingTop: 20 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                            <input id="import-bilant" type="file" accept="file/*"
                                                onChange={() => { this.importBilant('import-bilant') }}
                                                style={{ display: 'none' }}
                                            ></input>
                                            <Button
                                                style={{ marginRight: 20 }}

                                                className={'add-button-blue'} onClick={() => { this.addBilantImport() }}  >

                                                <i style={{
                                                    fontSize: 20,
                                                    marginRight: 10
                                                }} className='material-icons'>upload_file</i>  {this.dictionary.financiar.importaBilant}
                                            </Button>



                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>


                        <Grid item style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                            <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginBottom: 20, textAlign: 'left' }}>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'middle' }} className='material-icons'>error</i> <span style={{ fontSize: 11, fontWeight: 500 }}>
                                        {this.dictionary.financiar.bilantNouMesaj}</span>
                                </div>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} className='material-icons'>clear</i>
                                </div>

                            </div>


                        </Grid>
                    </Grid>
                </Grid>

            </div>
        )
    }




}


